import MainTemplate from "../MainTemplate.js";
import MyCardLeftSide from "./fragments/MyCardLeftSide";
import MyCardRightSide from "./fragments/MyCardRightSide";

const MyCardView = () => {
  return (
    <MainTemplate
      getUserInfo
      LeftSideComponent={(props) => <MyCardLeftSide {...props} />}
      MainComponent={(props) => <MyCardRightSide {...props} />}
    />
  );
};

export default MyCardView;
